<div>
    <acl-ngx-global-header *ngIf="isAuthenticated" [productName]="globalHeaderProps.productName"
        [accentColor]="globalHeaderProps.accentColor" [menuItems]="globalHeaderProps.menuItems"
        [buttons]="globalHeaderProps.buttons" [navbarZIndex]="globalHeaderProps.navbarZIndex"
        [dimmerZIndex]="globalHeaderProps.dimmerZIndex" [disableSearch]="globalHeaderProps.disableSearch">
    </acl-ngx-global-header>
    <acl-ngx-breadcrumbs *ngIf="breadcrumb.length && isAuthenticated" [breadcrumbs]="breadcrumb"></acl-ngx-breadcrumbs>
    <router-outlet></router-outlet>
</div>
<modal></modal>
<iframe id="loginFrame" src="about:blank" style="display: none;"></iframe>